(function () {
  'use strict';
  var boot = document.getElementById('mtg-contact-clicks');
  if (!boot || window.MTGContactClicks) return;
  var query = new URLSearchParams(location.search);
  var preview = boot.getAttribute('data-mode') !== 'live' || query.has('preview_theme_id') ||
    !!(window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role !== 'main')));
  var qa = query.get('mtg_debug') === '1';
  var diagnostic = {mode:preview?'preview':'live',status:'starting',mapped:[],events:[]};
  var diagnosticNode, privacyRequested = false, attempts = 0, poll;
  function permitted() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  function destination(anchor) {
    try {
      var raw = (anchor.getAttribute('href') || '').trim();
      if (/^tel:/i.test(raw)) {
        var number = raw.slice(4).replace(/[\s().-]/g,'');
        return /^(?:\+61272578684|0272578684)$/.test(number) ? 'phone' : null;
      }
      var url = new URL(raw,location.href);
      if (url.protocol === 'https:' && !url.username && !url.password && !url.port &&
        url.hostname === 'goo.gl' && url.pathname === '/maps/wacSJumuYqkbh1xW7') return 'google_maps';
    } catch (_) {}
    return null;
  }
  function placement(anchor) {
    if (anchor.closest('header, [role="banner"], .shopify-section[id$="__header"]')) return 'header';
    if (anchor.closest('footer, [role="contentinfo"]')) return 'footer';
    for (var node=anchor, i=0; node && node !== document.body && i<8; node=node.parentElement,i++) {
      if (window.getComputedStyle(node).position === 'fixed') return 'floating';
    }
    return anchor.closest('main') ? 'content' : 'other';
  }
  function safePath() {
    var path = location.pathname;
    return path === '/' || /^\/(?:pages|products|collections|blogs|policies)\/[a-z0-9-]+(?:\/[a-z0-9-]+)?\/?$/.test(path) && path.length <= 180 ? path : '/other';
  }
  function pageType() {
    var path = safePath();
    if (path === '/') return 'home';
    return ({pages:'page',products:'product',collections:'collection',blogs:'blog',policies:'policy'})[path.split('/')[1]] || 'other';
  }
  function note() {
    document.documentElement.setAttribute('data-mtg-contact-clicks',diagnostic.status);
    if (!preview) return;
    if (!diagnosticNode) {
      diagnosticNode=document.createElement('script');
      diagnosticNode.id='mtg-contact-click-diagnostics';diagnosticNode.type='application/json';
      document.body.appendChild(diagnosticNode);
    }
    diagnostic.mapped=Array.from(document.querySelectorAll('a[href]')).map(function(a){
      var dest=destination(a);return dest?{destination:dest,placement:placement(a)}:null;
    }).filter(Boolean);
    diagnosticNode.textContent=JSON.stringify(diagnostic);
  }
  function refresh() {
    diagnostic.status=preview?'preview':!permitted()?'consent-blocked':typeof window.gtag!=='function'?'waiting-for-google-tag':'ready';
    note();
  }
  function loadPrivacy() {
    if (preview || privacyRequested || !(window.Shopify && typeof window.Shopify.loadFeatures==='function') || window.Shopify.customerPrivacy) return;
    privacyRequested=true;
    try {window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],refresh);}catch(_){}
  }
  document.addEventListener('click',function(event){
    try {
      if (event.defaultPrevented || event.button>0 || (!preview && event.isTrusted!==true)) return;
      var target=event.target;
      var anchor=target && target.closest && target.closest('a[href]');
      if (!anchor && typeof event.composedPath==='function') {
        anchor=event.composedPath().find(function(n){return n && n.matches && n.matches('a[href]');});
      }
      var dest=anchor && destination(anchor);
      if (!dest || (!preview && (!permitted() || typeof window.gtag!=='function'))) return;
      var params={send_to:'G-E64YVYMMTP',contact_placement:placement(anchor),contact_destination:dest,
        page_type:pageType(),page_location:location.origin+safePath(),page_referrer:'',
        measurement_version:'contact-v1',test_submission:preview||qa};
      if (qa) params.debug_mode=true;
      var name=dest==='phone'?'mtg_phone_click':'mtg_maps_click';
      if (preview) {
        diagnostic.events.push({event:name,params:params});
        if(diagnostic.events.length>30)diagnostic.events.shift();note();
      } else {window.gtag('event',name,params);}
    } catch (_) {} // Measurement must never alter navigation or dialling.
  });
  document.addEventListener('visitorConsentCollected',refresh);
  window.addEventListener('pageshow',refresh);
  window.MTGContactClicks={version:'contact-v1'};
  loadPrivacy();refresh();
  if(!preview)poll=window.setInterval(function(){loadPrivacy();refresh();if(++attempts>=60 || diagnostic.status==='ready')window.clearInterval(poll);},500);
}());
